<template>
  <div>
    <div class="quotation-nav">
      <woot-tabs :index="selectedTabIndex" @change="onClickTabChange">
        <woot-tabs-item
          v-for="tab in tabs"
          :key="tab.key"
          :name="tab.name"
          :show-badge="false"
        />
      </woot-tabs>
      <woot-button
        type="button"
        variant="clear"
        color-scheme="secondary"
        size="small"
        class="token-trigger"
        @click="showTokenModal = true"
      >
        {{ $t('INTEGRATION_APPS.FIPE.PLACA_FIPE_TOKEN.TITLE') }}
        <span :class="['token-status', hasToken ? 'is-ok' : 'is-missing']">
          {{
            hasToken
              ? $t('INTEGRATION_APPS.FIPE.PLACA_FIPE_TOKEN.CONFIGURED')
              : $t('INTEGRATION_APPS.FIPE.PLACA_FIPE_TOKEN.MISSING')
          }}
        </span>
      </woot-button>
    </div>

    <woot-modal :show.sync="showTokenModal" :on-close="closeTokenModal">
      <div class="column content-box">
        <woot-modal-header
          :header-title="$t('INTEGRATION_APPS.FIPE.PLACA_FIPE_TOKEN.TITLE')"
          :header-content="$t('INTEGRATION_APPS.FIPE.PLACA_FIPE_TOKEN.HELP')"
        />
        <form class="row" @submit.prevent="saveToken">
          <div class="medium-12 columns">
            <label>
              {{ $t('INTEGRATION_APPS.FIPE.PLACA_FIPE_TOKEN.TITLE') }}
              <input
                v-model="token"
                type="password"
                autocomplete="new-password"
                :placeholder="
                  $t('INTEGRATION_APPS.FIPE.PLACA_FIPE_TOKEN.PLACEHOLDER')
                "
              />
            </label>
            <div class="modal-footer">
              <woot-button
                type="submit"
                :is-disabled="!token.trim() || saving"
                :is-loading="saving"
              >
                {{ $t('INTEGRATION_APPS.FIPE.PLACA_FIPE_TOKEN.SAVE') }}
              </woot-button>
              <woot-button
                v-if="hasToken"
                type="button"
                variant="clear"
                color-scheme="alert"
                :is-disabled="saving"
                @click="removeToken"
              >
                {{ $t('INTEGRATION_APPS.FIPE.PLACA_FIPE_TOKEN.REMOVE') }}
              </woot-button>
              <woot-button
                type="button"
                variant="clear"
                :is-disabled="saving"
                @click="closeTokenModal"
              >
                {{ $t('INTEGRATION_APPS.ADD.FORM.CANCEL') }}
              </woot-button>
            </div>
          </div>
        </form>
      </div>
    </woot-modal>

    <div class="row">
      <plan v-if="selectedTabIndex == 0" :integration="integration" />

      <fipe v-if="selectedTabIndex == 1" :integration="integration" />
    </div>
  </div>
</template>

<script>
import Plan from './Plan.vue';
import Fipe from './Fipe.vue';
import alertMixin from 'shared/mixins/alertMixin';
export default {
  name: 'Quotation',
  components: { Plan, Fipe },
  mixins: [alertMixin],
  props: {
    integration: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      selectedTabIndex: 0,
      showTokenModal: false,
      token: '',
      saving: false,
    };
  },

  computed: {
    hook() {
      return this.integration.hooks?.[0] || null;
    },
    hasToken() {
      return Boolean(this.hook?.settings?.placa_fipe_token);
    },
    tabs() {
      return [
        {
          key: 0,
          name: this.$t('INTEGRATION_APPS.FIPE.TABS.QUOTATION_PLAN'),
        },
        {
          key: 1,
          name: this.$t('INTEGRATION_APPS.FIPE.TABS.FIPE'),
        },
      ];
    },
  },

  methods: {
    onClickTabChange(index) {
      this.selectedTabIndex = index;
    },
    closeTokenModal() {
      this.showTokenModal = false;
      this.token = '';
    },
    async saveToken() {
      const value = this.token.trim();
      if (!value || !this.hook) return;
      await this.persistToken(
        value,
        'INTEGRATION_APPS.FIPE.PLACA_FIPE_TOKEN.SAVED'
      );
    },
    async removeToken() {
      if (!this.hook) return;
      await this.persistToken(
        '',
        'INTEGRATION_APPS.FIPE.PLACA_FIPE_TOKEN.REMOVED'
      );
    },
    async persistToken(value, successKey) {
      this.saving = true;
      try {
        await this.$store.dispatch('integrations/updateHook', {
          hookId: this.hook.id,
          data: {
            hook: {
              settings: {
                ...this.hook.settings,
                placa_fipe_token: value,
              },
            },
          },
        });
        this.closeTokenModal();
        this.showAlert(this.$t(successKey));
      } catch (error) {
        this.showAlert(this.$t('INTEGRATION_APPS.FIPE.PLACA_FIPE_TOKEN.ERROR'));
      } finally {
        this.saving = false;
      }
    },
  },
};
</script>
<style scoped lang="scss">
.quotation-nav {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: var(--space-small);
  flex-wrap: wrap;
}

.token-trigger {
  flex-shrink: 0;
  margin-bottom: 0;
}

.token-status {
  margin-left: var(--space-smaller);

  &.is-ok {
    color: var(--g-700);
  }

  &.is-missing {
    color: var(--y-700);
  }
}
</style>
